import React, {Fragment, useState} from 'react';
import {Button, Col, Input, Row} from 'antd';
import 'flag-icon-css/css/flag-icon.css';
import {translate} from 'react-i18next';
import {compose} from 'redux';

import "./style.css";
import EnhancedModal from "../enhanced-modal";
import CodeEditorTextArea from '../code-editor-text-area';
import {GUTTER_SM, MODAL_WIDTH_MD} from "../../styles/constants";

const ZoomableHighlightedTextArea = ({
                                         t,
                                         value,
                                         disabled = false,
                                         onChange,
                                         onClear,
                                         onBlur,
                                         modalProps = {}
                                     }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    return (
        <Fragment>
            <EnhancedModal
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={
                    <Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                        {onClear && (<Col>
                            <Button onClick={() => onClear()} disabled={!value}>
                                {t('commons.buttons.clear.title')}
                            </Button>
                        </Col>)}
                        <Col>
                            <Button onClick={() => setIsModalVisible(false)} icon="zoom-out">
                                {t('commons.buttons.close.title')}
                            </Button>
                        </Col>
                    </Row>
                }
                width={MODAL_WIDTH_MD}
                title="&nbsp;"
                {...modalProps}
            >
                <div style={{
                    width: '100%',
                    height: '100%',
                    overflow: "auto",
                }}
                     className="codeEditorModalContainer"
                >
                    <CodeEditorTextArea
                        value={value}
                        className="codeEditor"
                        onChange={e => {
                            if (onChange) {
                                onChange(e.target.value)
                            }
                        }}
                        onBlur={onBlur}
                        language="SQL"
                        disabled={disabled}
                    />
                </div>
            </EnhancedModal>
            <Input.Group
                compact
                className="zoomable-textarea__input-group"
                style={{position: "relative", height: "100%", borderColor: 'red'}}
            >
                <Button icon="zoom-in" style={{position: "absolute", height: "100%"}}
                        onClick={() => setIsModalVisible(true)}/>
                <div style={
                    {
                        width: 'calc(100% - 32px)',
                        height: '100%',
                        left: 32,
                        position: "absolute",
                        overflow: "auto",
                    }
                }
                     className="codeEditorContainer"
                >
                <CodeEditorTextArea
                    value={value}
                    language="SQL"
                    disabled={disabled}
                    className="codeEditor"
                    onChange={e => {
                        if (onChange) {
                            onChange(e.target.value)
                        }
                    }}
                    onBlur={onBlur}
                />
                </div>
            </Input.Group>
        </Fragment>
    );
}

export default compose(
    translate(),
)(ZoomableHighlightedTextArea);
